import { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import { Parameter } from "../../common/types/parameters";
import SelectionCard from "../parameters/selection-card";
import NumericInputField from "../parameters/numeric-field";
import { Button } from "@mui/material";
import {
  Alternatives,
  BooleanRange,
  NumericParameterStyle,
  NumericRange,
  ParameterType,
} from "../../common/types/parameters";
import { getType } from "../data-presentation/util";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "stretch",
    padding: "20px 0",
  },
  numeric_field_container: {
    alignItems: "center",
  },
}));

export default function WizardSingleParameterBlock(params: {
  id: string;
  inputParameter: Parameter;
  preSelected?: string;
  onSelection?: (value: string) => void;
}) {
  const classes = useStyles();

  const [userInput, setUserInput] = useState<string | undefined>();

  useEffect(() => {
    setUserInput(params.preSelected);
  }, [params.preSelected]);

  let parameter = params.inputParameter;

  function getSelectionImage(
    imgName: string,
    index: number
  ): NodeRequire | undefined {
    if (getType(parameter) === ParameterType.Selection) {
      if (params.id === "DistrictSelected") {
        imgName = index === 0 ? "CityCentre" : `Suburb_${(index - 1) % 5}`;
      }
      try {
        return require(`../../assets/img/parameters/${imgName}.jpg`);
      } catch {
        return undefined;
      }
    } else {
      return undefined;
    }
  }

  return parameter ? (
    <div
      className={classes.container}
      key={`wizard-parameter-${params.id}-block`}
    >
      {(getType(parameter) === ParameterType.Selection &&
        (parameter.constraints as Alternatives).map((alternative, index) => (
          <SelectionCard
            value={alternative.id}
            title={alternative.displayName}
            description={alternative.description}
            image={getSelectionImage(alternative.id, index)}
            selected={userInput === JSON.stringify(alternative)}
            onClick={() => {
              setUserInput(JSON.stringify(alternative));
              if (params.onSelection) {
                params.onSelection(JSON.stringify(alternative));
              }
            }}
          />
        ))) ||
        (getType(parameter) === ParameterType.YesNo &&
          (parameter.constraints as BooleanRange).map((alternative, index) => (
            <SelectionCard
              value={alternative}
              title={alternative ? "Ja" : "Nej"}
              description={undefined}
              image={undefined}
              selected={userInput === JSON.stringify(alternative)}
              onClick={() => {
                setUserInput(JSON.stringify(alternative));
                if (params.onSelection) {
                  params.onSelection(JSON.stringify(alternative));
                }
              }}
            />
          ))) ||
        (getType(parameter) === ParameterType.Numeric && (
          <div
            className={`${classes.container} ${classes.numeric_field_container}`}
            key={`wizard-parameter-${params.id}-container`}
          >
            <NumericInputField
              inputId={parameter.id}
              min={(parameter.constraints as NumericRange)?.min}
              max={(parameter.constraints as NumericRange)?.max}
              defaultValue={userInput}
              title={`
                ${parameter.displayName}
                ${
                  (parameter.stylingConfig as NumericParameterStyle)?.unit
                    ? `(${
                        (parameter.stylingConfig as NumericParameterStyle).unit
                      })`
                    : ""
                }`}
              description={parameter.description}
              onValidChange={(id: string, val: string) => {
                setUserInput(val);
              }}
              onErroneousChange={(
                id: string,
                val: string,
                nearestValidVal: string
              ) => {
                setUserInput(undefined);
              }}
              numDecimals={
                (parameter.stylingConfig as NumericParameterStyle)?.numDecimals
              }
              thousandsSeparator={
                (parameter.stylingConfig as NumericParameterStyle)
                  ?.thousandsSeparator
              }
              decimalSeparator={
                (parameter.stylingConfig as NumericParameterStyle)
                  ?.decimalSeparator
              }
              unit={(parameter.stylingConfig as NumericParameterStyle)?.unit}
              includeVat={false}
            />
            <Button
              disabled={userInput === undefined}
              size="small"
              variant="contained"
              onClick={() => {
                if (params.onSelection && userInput !== undefined) {
                  params.onSelection(userInput);
                }
              }}
            >
              Nästa
            </Button>
          </div>
        ))}
    </div>
  ) : null;
}
